import type { cv_StandardPhrase } from './cv-standard-phrase.interface';

export interface cv_StandardPhraseLinkType {
    C_StandardPhraseLinkType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    StandardPhraseLinkType: string;
    Version: number;
    cv_StandardPhrase: cv_StandardPhrase[];
}
